import React from 'react';
import ReactMarkdown from 'react-markdown';
import { twMerge } from 'tailwind-merge';

const Headline = ({
  children,
  className,
  line = 'top' | 'right' | 'botton' | 'left',
  light,
  mark = true,
  ...props
}) => {
  return (
    <div
      className={twMerge(
        'relative text-left text-lg lg:text-[22px] font-epilogue font-light leading-normal uppercase',
        light ? 'text-white' : 'text-new-dark-75 group-data-[light="true"]:text-white',
        line === 'left'
          ? light
            ? 'pl-4 border-l border-new-light-75'
            : 'pl-4 border-l border-new-dark-75 group-data-[light="true"]:border-new-light-75'
          : '',
        line === 'bottom'
          ? light
            ? 'after:content-[""] after:absolute after:inset-x-0 after:-bottom-3 after:h-px after:w-8 after:left-0 after:bg-white after:bg-opacity-30'
            : 'after:content-[""] after:absolute after:inset-x-0 after:-bottom-3 after:h-px after:w-8 after:left-0 after:bg-black after:bg-opacity-30 group-data-[light="true"]:after:bg-white'
          : '',
        className,
      )}
      {...props}
    >
      {mark ? <ReactMarkdown>{children}</ReactMarkdown> : children}
    </div>
  );
};

export default Headline;
